////////
// Search Overlay
// ---------------
// @desc 		Overlay object that envelopes all .search.overlay DOM objects
// @param		DOM element
////////
var SearchOverlay = function() {

	App.log("SearchOverlay: [Init]");

	var obj = this; // Lazy scope helper

	this.selectors = {
		navButton: ".nav-search a",
    overlay: ".search.overlay",
		outer: ".outer",
    inner: ".outer > .inner",
		logo: ".site-header .site-logo",
		input: "input[name='q']",
		close: ".close",
		noResult: ".no-results",
		queryTag: ".query",
		results: ".results"
	};

	this.flags = {
		ACTIVE: "active",
    NO_SCROLL: "no-scroll",
		LIGHT: "o-light"
	};

	this.templates = {

		result: '\
		<a class="result" href="{{url}}">\
			<p class="title h4">{{title}}</p>\
			<p class="desc">{{desc}}</p>\
			<span class="url">{{url}}</span>\
		</a>',

		noResult: '\
		<h3>No results found</h3>\
	    <p>Your search for <span class="query"></span> didn\'t return any results</p>'
	};

	this.element = $(this.selectors.overlay);
	this.outer = this.element.find(this.selectors.outer);
	this.form = this.element.find("form");
	this.noResult = this.element.find(this.selectors.noResult);
	this.results = this.element.find(this.selectors.results);

	// Other parts to fulfil overlay functionality
  this.innerDOM = this.element.find(this.selectors.inner)[0];
	this.logo = $(this.selectors.logo);

	// Close button
  this.closeButton = $(this.element.find(this.selectors.close));
	this.closeButton.on("click", this, this.close);
	this.element.on("click", this, this.close);
	// this.outer.on("click", this, this.close);

	// Open button
	this.openButton = $(this.selectors.navButton);
	if(this.openButton) {
		this.openButton.on("click", this, this.open);
	}

	// Prevent form submission
	this.form.on("submit", function(e) {
		// Nien to bubbling
		return(false);
	});

	// Render objects for result
	this._updateInterface = function(results, queryValue) {

		// Clarify search object scope
		var searchObj = this;
		var q = searchObj.getSearchValue();

		// Filter results
		if(results.length < 1) {

            obj.noResult.html(obj.templates.noResult.trim());
            obj.noResult.find('.query')[0].textContent = q;
            obj.results.hide();
            obj.noResult.show();

		} else {

			// Hide no results message
			obj.noResult.hide();

			// Clear results block
			obj.results.empty();

			// Render results
			var resultCollection = [];
			for(var i = 0; i<results.length; i++) {
				var result = results[i];
				resultCollection.push(
					App.Utilities.mapPlaceholderTemplate(obj.templates.result, {
						url: result.url,
						desc: result.description || '',
						title: result.title
					})
				);
			}

			if(resultCollection.length) {
				var html = '<h3><span class="count">' + resultCollection.length + '</span> results found</h3>' + resultCollection.join("");
				obj.results.append(html);
				obj.noResult.hide();
				obj.results.show();
			}

		}
	};

	// Get the input values and setup a Search object
	var input = this.element.find(this.selectors.input);
	this.input = $(input);
	this.search = new Search(input, this._updateInterface);
}


/***
* Callback for checking overlay is active
***/
SearchOverlay.prototype.isActive = function() {
  return(
    this.element.hasClass(this.flags.ACTIVE)
  );
}


/***
* Callback to close the overlay
***/
SearchOverlay.prototype.close = function(e) {
	var obj = e.data || this;
	if(	e.target == obj.closeButton[0] || e.target == obj.element[0]) {
		gsap.fromTo([obj.element, obj.outer], { opacity:1 }, { opacity:0, duration: .5, stagger:.3, onComplete: function() {
			obj.element.removeClass(obj.flags.ACTIVE);
			$("body").removeClass(obj.flags.NO_SCROLL);
		} });
		return(false);
	}
}


/***
* Open's the overlay
***/
SearchOverlay.prototype.open = function(e) {
	var obj = e.data || this;

	if(obj.onOpen) {
		// Tight backcall to controller
		obj.onOpen(obj);
	}

	// Add classes
  $("body").addClass(obj.flags.NO_SCROLL);
	// obj.logo.addClass(obj.flags.LIGHT);
	obj.element.addClass(obj.flags.ACTIVE);

	gsap.fromTo(obj.element, { opacity:0 }, { opacity:1, duration: .5 })
	gsap.fromTo(obj.outer, { x:-100, autoAlpha:0 }, { x:0, autoAlpha:1, delay:.5, duration: .5 })

	// Stop bubbling
	return(false);
}
